// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/runway-gradient-landing-run.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/runway-gradient-landing-run/runway-gradient-landing-run.js';

mount([g0]);
